import httpClient from "@/services/httpClient";
import { server } from "@/services/constants";

export const getVoteReport = (body) => {
    return httpClient.post(server.VOTE_URL + '/report-pdf', body);
};